module.exports = __webpack_public_path__ + "img/cards.2afad80b.svg";